module.exports = "<div class=\"bell\">\r\n  \r\n  <span class=\"unread\" [hidden]=\"unreadAmount == 0\">{{unreadAmount}}</span>\r\n  <i class=\"fa fa-bell-o\" [routerLink]=\"['/profile/notification']\" aria-hidden=\"true\"  placement=\"bottom\"></i>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/bell-notify-user/bell-notify-user.component.html
// module id = ./src/app/shared/components/bell-notify-user/bell-notify-user.component.html
// module chunks = main